import Layout from '@/views/layout';

const incomeRouter = {
  path: '/income',
  name: 'Income',
  component: Layout,
  meta: { title: '收益', roles: [0, 1, 2, 3, 4], noCache: true },
  redirect: { name: 'IncomeList' },
  children: [
    {
      path: 'incomeList',
      name: 'IncomeList',
      component: () => import('@/views/income'),
      meta: { title: '收益', roles: [0, 1, 2, 3, 4], noCache: true }
    }
  ]
};

export default incomeRouter;